export default "__VITE_ASSET__DCyc$0f$__"